(function () {
  // Add to cart without leaving the page. Every /cart/add form (PDP, sticky
  // bar, cta-checkout, product cards) is posted with fetch instead of a full
  // page load. Assortion patches window.fetch and opens its cart drawer when it
  // sees a /cart/add request, so the drawer slides out on add.
  //
  // Why this exists: Assortion only intercepts a native form submit when it has
  // add-to-cart offers to apply; otherwise it lets the browser POST to /cart.
  // The old theme cart drawer used to post via fetch (which is what made the
  // drawer slide out). With that drawer removed, this script does the same job.
  // Runs on document (bubble) so it goes before Assortion's window listener.
  // Opt out per form with data-no-ajax.
  if (window.__ldAjaxCart) return;
  window.__ldAjaxCart = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function showError(form, msg) {
    var el = form.querySelector('[data-ajax-cart-error]');
    if (!el) {
      el = document.createElement('p');
      el.className = 'ajax-cart-error';
      el.setAttribute('data-ajax-cart-error', '');
      el.setAttribute('role', 'alert');
      form.appendChild(el);
    }
    el.textContent = msg;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement) || e.defaultPrevented) return;
    if ((form.getAttribute('method') || '').toLowerCase() !== 'post') return;
    if (!/\/cart\/add(\.js)?(\?|$)/.test(form.getAttribute('action') || '')) return;
    if (form.hasAttribute('data-no-ajax')) return;
    e.preventDefault();

    var btn = e.submitter || form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');
    var prevError = form.querySelector('[data-ajax-cart-error]');
    if (prevError) prevError.textContent = '';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, data: data }; });
      })
      .then(function (r) {
        if (!r.ok) {
          showError(form, (r.data && (r.data.description || r.data.message)) || 'Could not add to cart. Please try again.');
          return;
        }
        // Assortion's fetch hook opens the drawer. Without the app, go to the cart page.
        if (!window.Assortion || !window.Assortion.cart) window.location.href = root + 'cart';
      })
      .catch(function () {
        HTMLFormElement.prototype.submit.call(form);
      })
      .then(function () {
        if (btn) btn.removeAttribute('aria-busy');
      });
  });
})();
